import { createApp } from "vue";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import VueTheMask from "vue-the-mask";
import App from "./App.vue";

import "bootstrap/dist/css/bootstrap.css";

const firebaseConfig = {
  apiKey: "AIzaSyBFCFgzgiclgENrh5qCopDHkeNR-1HmIbA",
  authDomain: "teste-de-conhecimento-f4598.firebaseapp.com",
  projectId: "teste-de-conhecimento-f4598",
  storageBucket: "teste-de-conhecimento-f4598.firebasestorage.app",
  messagingSenderId: "76832645630",
  appId: "1:76832645630:web:3612977f8c5c43dd52a0af",
};

const appInstance = initializeApp(firebaseConfig);
export const database = getDatabase(appInstance);
const app = createApp(App);
app.use(VueTheMask);
app.mount("#app");
